module.exports = __webpack_public_path__ + "static/Gerda-blur-over-c18afc5d064bed91edde52f0f9fceff4.jpg";